/* tslint:disable */
import { AppConfig } from './model';

export const config: AppConfig = {
    'apiGatewayUrl' : 'apigateway/',
    'onBoardingAppDomain': isAbsoluteUrl(MICROAPPS_URLS['onboarding']) ? MICROAPPS_URLS['onboarding'] : window.location.origin + MICROAPPS_URLS['onboarding'],
    'dashboardAppDomain': isAbsoluteUrl(MICROAPPS_URLS['dashboard']) ? MICROAPPS_URLS['dashboard'] : window.location.origin + MICROAPPS_URLS['dashboard'],
    'adminAppDomain': isAbsoluteUrl(MICROAPPS_URLS['admin']) ?  MICROAPPS_URLS['admin'] : window.location.origin + MICROAPPS_URLS['admin'],
    'classAppDomain': isAbsoluteUrl(MICROAPPS_URLS['class']) ?  MICROAPPS_URLS['class'] : window.location.origin + MICROAPPS_URLS['class'],
    'customReqHeaders' : {
        'appVersion' : {
            'key' : 'cambridgeone-app-version',
            'value' : 'v2'
        },
        'userRole' : {
            'key' : 'user-role'
        },
        'userId' : {
            'key' : 'user-id'
        }
    }
};

function isAbsoluteUrl(url) {
    let pat = /(^https?:\/\/)|(^\/\/)/i;
    return pat.test(url);
}


